// @flow

import _ from 'lodash';
import React from 'react';

import EnrollmentPeriodModel from 'routes/health/models/EnrollmentPeriodModel';
import MissedCutoffWarning from 'routes/cart/components/deadline/MissedCutoffWarning';
import NearCutoffWarning from 'routes/cart/components/deadline/NearCutoffWarning';

import type { CartDeadlineTranslationsType } from 'routes/cart/types';

export const DEADLINE_TRANSLATE_PREFIX = 'cart.deadlineTranslations';

type Props = {
  carrierName: string,
  deadlineTranslations: CartDeadlineTranslationsType,
  enrollmentPeriodInfo: EnrollmentPeriodModel,
  isFFM: boolean,
  onExchange: boolean,
  stateExchange: {
    name: string,
    websiteUrl: string,
  },
  stateName: string,
};

const DeadlineWarning = ({
  carrierName,
  deadlineTranslations,
  enrollmentPeriodInfo,
  isFFM,
  onExchange,
  stateExchange,
  stateName,
  partnerDisplayName,
}: Props) => {
  const {
    effectiveDate,
    enrollmentPeriod,
    isPeriodEnd,
    nextEffectiveDate,
    showCutoffMissed,
    showCutoffNear,
  } = enrollmentPeriodInfo;
  return (
    <React.Fragment>
      {!_.isEmpty(enrollmentPeriod) && !_.isEmpty(deadlineTranslations) && (
        <div className="center-col-medium text-center pad-y pad-x-small-only">
          {showCutoffNear && (
            <NearCutoffWarning
              effectiveDate={effectiveDate}
              strideEndDate={enrollmentPeriod.stride_end_date}
              translations={deadlineTranslations} />
          )}
          {showCutoffMissed && (
            <MissedCutoffWarning
              carrierName={carrierName}
              effectiveDate={effectiveDate}
              isFFM={isFFM}
              isPeriodEnd={isPeriodEnd}
              nextEffectiveDate={nextEffectiveDate}
              officialEndDate={enrollmentPeriod.official_end_date}
              onExchange={onExchange}
              stateExchange={stateExchange}
              stateName={stateName}
              translations={deadlineTranslations}
              partnerDisplayName={partnerDisplayName} />
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default DeadlineWarning;
